export default {"src":"/_next/static/media/Close.ab77045c.svg","height":12,"width":12};